var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownDecIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.99995 6.25C4.84658 6.24989 4.69687 6.29679 4.57099 6.38439C4.44511 6.47199 4.3491 6.59608 4.29592 6.73993C4.24274 6.88378 4.23494 7.04047 4.27357 7.18889C4.31219 7.33731 4.39539 7.47033 4.51195 7.57L11.5119 13.57C11.7919 13.81 12.2069 13.81 12.4879 13.57L19.4879 7.57C19.6045 7.47033 19.6877 7.33731 19.7263 7.18889C19.765 7.04047 19.7572 6.88378 19.704 6.73993C19.6508 6.59608 19.5548 6.47199 19.4289 6.38439C19.303 6.29679 19.1533 6.24989 18.9999 6.25H4.99995Z",
    fill: "url(#paint0_linear_4293_305)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43006 10.512C4.49418 10.4372 4.57243 10.3757 4.66032 10.3312C4.74821 10.2866 4.84402 10.2598 4.94227 10.2523C5.04053 10.2447 5.1393 10.2566 5.23295 10.2873C5.3266 10.318 5.41329 10.3668 5.48806 10.431L12.0001 16.012L18.5121 10.431C18.5867 10.3661 18.6735 10.3167 18.7674 10.2855C18.8612 10.2543 18.9604 10.242 19.059 10.2492C19.1577 10.2565 19.2539 10.2832 19.3422 10.3278C19.4305 10.3724 19.5091 10.4341 19.5734 10.5092C19.6378 10.5843 19.6867 10.6714 19.7172 10.7655C19.7478 10.8596 19.7594 10.9588 19.7515 11.0574C19.7436 11.156 19.7162 11.252 19.671 11.34C19.6258 11.428 19.5636 11.5061 19.4881 11.57L12.4881 17.57C12.3521 17.6865 12.179 17.7505 12.0001 17.7505C11.8211 17.7505 11.648 17.6865 11.5121 17.57L4.51206 11.57C4.43723 11.5059 4.37578 11.4276 4.33121 11.3397C4.28664 11.2519 4.25983 11.156 4.25231 11.0578C4.24479 10.9595 4.2567 10.8608 4.28737 10.7671C4.31804 10.6735 4.36687 10.5868 4.43106 10.512H4.43006Z",
    fill: "url(#paint1_linear_4293_305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4293_305",
    x1: 4.24939,
    y1: 6.25,
    x2: 10.1302,
    y2: 18.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4293_305",
    x1: 4.25012,
    y1: 10.2472,
    x2: 10.1345,
    y2: 22.4059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDecIcon);
export default __webpack_public_path__ + "static/media/downDecIcon.9a73ea768efc8d66be3d1e0a19a09fa9.svg";
export { ForwardRef as ReactComponent };